import { Button, Stack, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const UploadFileButton = ({ file, label, handleFileChange }) => {
  return (
    <>
      <input
        accept="image/*"
        style={{ display: "none" }}
        onChange={handleFileChange}
        id="raised-button-file"
        multiple
        type="file"
      />

      <Stack direction={"vertical"}>
        <label htmlFor="raised-button-file">
          <Button
            variant={file ? "contained" : "outlined"}
            color={file ? "success" : "info"}
            component="span"
            startIcon={<CloudUploadIcon />}
          >
            {label ? label : "Upload"}
          </Button>
          <Typography>{file && file.name}</Typography>
        </label>
      </Stack>
    </>
  );
};

export default UploadFileButton;
